// 어드민 이미지 업로드/정보 수정 페이지 상단의 '분류' Select를 위한 enum
export enum CategorySelectEnum {
  STANDARD = '스탠다드 검색',
  ADULTS_ONLY = '19금'
}
